const {bind} = require('../lib/bind')

module.exports = class Fullscreen {
  constructor(element) {
    this.element = element;
    bind(element.querySelector('.js-fullscreen-toggle'), 'click', this.toggle.bind(this))
    bind(document, 'fullscreenchange', this.toggleState.bind(this))
    bind(document, 'webkitfullscreenchange', this.toggleState.bind(this))
    bind(document, 'mozfullscreenchange', this.toggleState.bind(this))
    this.element.classList.add('fullscreen-supported')
  }

  supported() {
    return document.fullscreenEnabled ||
    document.mozFullScreenEnabled ||
    document.webkitFullscreenEnabled;
  }

  cancel() {
    return (
      document.cancelFullScreen ||
      document.mozCancelFullScreen ||
      document.webkitCancelFullScreen ||
      this.forceCancel.bind(this)
    ).call(document);
  }

  request() {
    return (
      this.element.requestFullScreen ||
      this.element.mozRequestFullScreen ||
      this.element.webkitRequestFullScreen ||
      this.forceRequest.bind(this)
    ).call(this.element);
  }

  forceRequest() {
    window.frameElement.dispatchEvent(new CustomEvent('sd:embed:fullscreen:on'))
    this.element.classList.add('is-fullscreen');
  }

  forceCancel() {
    window.frameElement.dispatchEvent(new CustomEvent('sd:embed:fullscreen:off'))
    this.element.classList.remove('is-fullscreen');
  }

  toggle() {
    if (this.isFullscreen()) {
      this.cancel();
    } else {
      this.request();
    }
  }

  isFullscreen() {
    if (this.supported()) {
      return this.element === (
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement
      )
    } else {
      return this.element.classList.contains('is-fullscreen');
    }
  }

  toggleState() {
    if (this.isFullscreen()) {
      return this.element.classList.add('is-fullscreen');
    } else {
      return this.element.classList.remove('is-fullscreen');
    }
  }
}
